import { apiClient } from '../client';

/**
 * Busca responsáveis de um aluno pela tabela users (role RESPONSABLE)
 * @param {string} studentIdSponte - ID Sponte do aluno
 * @param {string} unit - Unidade (opcional)
 * @returns {Promise<Array>} Lista de responsáveis
 */
export const getResponsablesByStudent = async (studentIdSponte, unit) => {
  const { data } = await apiClient.post('/users/responsables-by-student', {
    studentIdSponte,
    unit,
  });
  return data.data || [];
};


